(function ($) {
  // The purpose of this plugin is to allow the toggling of visibility on select
  // options.  It may seem strange, but this was the only approach I could find
  // that worked cross browser and didn't involve moving the hidden option
  // elements around the dom.
  // Based on code from: http://stackoverflow.com/questions/9234830
  jQuery.fn.toggleOption = function (show) {
    $(this).toggle(show);
    if (show) {
      if ($(this).parent('span.toggleOption').length) {
        $(this).unwrap();
      }
    } else {
      if ($(this).parent('span.toggleOption').length===0) {
        $(this).wrap('<span class="toggleOption" style="display: none;" />');
      }
    }
  };
}(jQuery));
